import React from "react";
import "./app.css";
const BahasaTerms = ({ cardData, activetab }) => {
  return (
    <div>
      <div className="card-body"></div>
      <div
        style={{
          border: "1px solid black",
          padding: "50px",
          margin: "10px",
          borderRadius: "10px",
        }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: cardData?.bahasa_description,
          }}
        />
      </div>
    </div>
  );
};

export default BahasaTerms;
